import { rowColumn } from "../../components/table/Table";
import { AuthorisationLevel } from "../enums/AuthorisationLevel";

const userLinkListTable = (isManager: boolean): rowColumn[] => {
  return [
    {
      label: "Display name",
      column: "user.displayName",
      type: "string",
      allowSort: true,
      isVisible: true,
    },
    {
      label: "Email",
      column: "user.userEmail",
      type: "string",
      allowSort: true,
      isVisible: true,
    },
    {
      label: "Authorisation level",
      column: "authorisationLevel",
      type: "enum",
      enumType: AuthorisationLevel,
      allowSort: true,
      isVisible: true,
    },
    {
      label: "Actions",

      body: (rowData) => <a href={`${rowData.linkId}/${rowData.id}`}>{isManager ? "Edit Details" : "View Details"}</a>,
    },
  ];
};

export default userLinkListTable;
